export default __webpack_public_path__ + "static/quality_main-50ab72bd80a2c10538f0162d80952063.png";